import React from 'react';
import classNames from 'classnames';
import Head from 'next/head';
import bannerStyles from './Banner-tw-styles';
import headingStyles from '../Heading/Heading-tw-styles';
import getWidth from '../../../utils/gridWidth';
import { VideoButton, VideoDialog } from '../../Generic/VideoButton';
import richTextStyles from '../Richtext/Richtext-tw-styles';
import { getButton, getBannerImageButton } from '../../../utils/uiHelper';
import { getCdnImage } from '../../../utils/ImageManager';
import i18nMessages from '../../../constants/messages/pt-BR';
import DOMPurify from 'isomorphic-dompurify'
import Typography from '../../Generic/Typography';
import Product from '../Product';
import videoButtonStyles from '../../Generic/VideoButton/VideoButton-tw-styles';
import { CardMedia, Card, CardContent } from '../../Generic/Card';

class Banner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogStatus: false,
      dialogobject: {},
      isMobile: false,
    };
  }

  componentDidMount() {
    const isMobile = window.innerWidth < 768;
    this.setState({
      isMobile: isMobile,
    });
  }

  handleDiaogOpen = videoData => {
    this.setState({ dialogStatus: true, dialogobject: videoData });
  };

  handleDiaogClose = () => {
    this.setState({ dialogStatus: false, dialogobject: {} });
  };

  render() {
    const bannerData = this.props;
    const locale= "pt-br";
    const widthClass = getWidth(bannerData.componentWidth);
    let bannerType = bannerData.styles && bannerData.styles.trim();
    if (bannerStyles[bannerType] === undefined) {
      bannerType = i18nMessages.bannertextleft;
    }
    const { dialogStatus, dialogobject, isMobile } = this.state;
    return (
      <>
        <Head>
          {bannerData.badgeImagesCollection &&
            bannerData.badgeImagesCollection.items.length > 0 && <link
              rel="preload"
              href={bannerData?.image?.smartphoneImage &&
                bannerData?.image?.smartphoneImage?.url ? getCdnImage(bannerData.image.smartphoneImage.url) : ''}
              as="image"
            />
          }
          
        </Head>
        <div className={classNames(bannerStyles.bannerdialog)}>
          {dialogStatus && (
            <VideoDialog
              video={dialogobject.video}
              handleClose={this.handleDiaogClose}
              styleName={dialogobject.dialogStyles}
            />
          )}

          <Card
            className={classNames(
              bannerStyles[bannerType].cardWrapper,
              widthClass
            )}
          >
            {(bannerData.contentCollection ||
              bannerData.badgeImagesCollection ||
              bannerData.callToActionCollection) && (
              <CardContent
                 tabIndex="-1"
                className={classNames(
                  bannerStyles[bannerType].container,
                  bannerStyles.contentPosition[bannerData.contentPosition] &&
                    bannerStyles.contentPosition[bannerData.contentPosition]
                      .container
                )}
                role="region"
              >
                <div
                  className={classNames(
                    bannerStyles[bannerType].contentWidth,
                    bannerStyles.contentPosition[bannerData.contentPosition] &&
                      bannerStyles.contentPosition[bannerData.contentPosition]
                        .textBlock
                  )}
                >
                  {bannerData.badgeImagesCollection &&
                    bannerData.badgeImagesCollection.items.length > 0 && (
                        <img
                          src={getCdnImage(
                            bannerData.badgeImagesCollection.items[0].image &&
                              bannerData.badgeImagesCollection.items[0].image.url
                          )}
                          className={classNames(
                            bannerStyles[bannerType].badgeImage
                          )}
                          alt={bannerData.badgeImagesCollection.items[0].altText}
                        />
                    )}
                  {bannerData.contentCollection &&
                    bannerData.contentCollection.items.map((item, i) => {
                      if (item && item.__typename === 'HeadingTypes') {
                        let headingStyle = '';
                        if (
                          item.styles &&
                          headingStyles[item.styles.trim()] !== undefined
                        ) {
                          headingStyle = headingStyles[item.styles.trim()];
                        }
                        return (
                          <Typography
                            key={bannerData.contentCollection.items[i].sys.id}
                            className={classNames(headingStyle)}
                            component="div"
                            dangerouslySetInnerHTML={
                              item.heading && {
                                __html:DOMPurify.sanitize( item.heading),
                              }
                            }
                          />
                        );
                      }
                    })}
                    {bannerData.image && 
                      (
                        isMobile ? ((bannerType == "marvel-banner-text-right" || bannerType == "marvel-banner-text-left") && 
                        (
                          <CardMedia
                                tabIndex="0"
                                component="picture"
                                image={
                                  bannerData.image.smartphoneImage &&
                                  bannerData.image.smartphoneImage.url
                                }
                                pictureLazyLoad={false}
                                imgClass={bannerStyles[bannerType].bannerImageSet}
                                srcset={
                                  bannerData?.image?.desktopImage &&
                                  bannerData?.image?.desktopImage?.url
                                }
                                alt={bannerData.image.altText}
                                mediaVariant={
                                  bannerData.variant === i18nMessages.HairBiology
                                    ? i18nMessages.minWidthBanner
                                    : i18nMessages.minWidthTwoBanner
                                }
                                height={isMobile ? 374 : 537}
                                width={isMobile ? 275 : 600}
                                lazyLoad={false}
                        />
                        ))
                        : null
                      )
                    }

                  {bannerData.contentCollection &&
                    bannerData.contentCollection.items.map((item, i) => {
                      if (item && item.__typename === 'ContentTypeRichText') {
                        let richtextStyle = '';
                        if (
                          item.styles &&
                          richTextStyles[item.styles.trim()] !== undefined
                        ) {
                          richtextStyle = richTextStyles[item.styles.trim()];
                        }
                        return (
                          <Typography
                            key={bannerData.contentCollection.items[i].sys.id}
                            className={classNames(
                              richtextStyle,
                              bannerStyles.bannerHelper.richtextMargin,
                              'contentfulRichText-spec'
                            )}
                            component="div"
                            dangerouslySetInnerHTML={
                              item.body && {
                                __html:DOMPurify.sanitize( item.body),
                              }
                            }
                          />
                        );
                      }
                    })}
                  {bannerData.callToActionCollection &&
                    bannerData.callToActionCollection.items.map((action, i) => {
                      switch (action.__typename) {
                        case i18nMessages.VideoButton:
                          if (action.video) {
                            return (
                              <div
                                className={classNames(
                                  bannerStyles.bannerHelper.buttonMargin,
                                  'contentfulVideoButton-spec'
                                )}
                                key={i}
                              >
                                <VideoButton
                                  {...action}
                                  styleName={videoButtonStyles[action.styles]}
                                  detachDialog
                                  onClick={this.handleDiaogOpen}
                                />
                              </div>
                            );
                          }
                          return null;
                        case i18nMessages.LinkButton:
                          return (
                            <div
                              key={i}
                              className={classNames(
                                bannerStyles[bannerType].bannerButton
                              )}
                            >
                              {getButton(action)}
                            </div>
                          );
                        case i18nMessages.ImageButton:
                          return getBannerImageButton(action);
                        default:
                          return null;
                      }
                    })}
                  <div className={classNames(
                                  bannerStyles[bannerType].releatedCard,
                                )}
                  >
                    {bannerData.relatedProductCollection && bannerData.relatedProductCollection.items.map((content,index)=>{
                    content.styles=i18nMessages.bannerReleatedCard
                  return (
                    <a href={`${i18nMessages.productPageURL+ content.parentPage.slug.toLowerCase() + '/' + content.slug}`} rel="preload">
                      <Product
                        locale={locale}
                        data={content}
                        key={index}
                      />
                    </a>
                  );
                })}
                  </div>
                </div>

              </CardContent>
            )}
             {bannerData.image && 
               (
                  isMobile ? ((bannerType !== "marvel-banner-text-right" && bannerType !== "marvel-banner-text-left") && 
                 (
                  <CardMedia
                        tabIndex="0"
                        component="picture"
                        image={
                          bannerData.image.smartphoneImage &&
                          bannerData.image.smartphoneImage.url
                        }
                        pictureLazyLoad={false}
                        imgClass={bannerStyles[bannerType].bannerImageSet}
                        srcset={
                          bannerData?.image?.desktopImage &&
                          bannerData?.image?.desktopImage?.url
                        }
                        alt={bannerData.image.altText}
                        mediaVariant={
                          bannerData.variant === i18nMessages.HairBiology
                            ? i18nMessages.minWidthBanner
                            : i18nMessages.minWidthTwoBanner
                        }
                        height={isMobile ? 374 : 537}
                        width={isMobile ? 275 : 600}
                        lazyLoad={false}
                />
                 ))
                : (
                  <CardMedia
                        tabIndex="0"
                        component="picture"
                        image={
                          bannerData.image.smartphoneImage &&

                          bannerData.image.smartphoneImage.url
                        }
                        pictureLazyLoad={false}
                        imgClass={bannerStyles[bannerType].bannerImageSet}
                        srcset={
                          bannerData?.image?.desktopImage &&
                          bannerData?.image?.desktopImage?.url
                        }
                        alt={bannerData.image.altText}
                        mediaVariant={
                          bannerData.variant === i18nMessages.HairBiology
                            ? i18nMessages.minWidthBanner
                            : i18nMessages.minWidthTwoBanner
                        }
                        height={isMobile ? 374 : 537}
                        width={isMobile ? 275 : 600}
                        lazyLoad={false}
                />
                 )
                )
             }
          </Card>
        </div>
      </>
    );
  }
}
export default Banner;
